import React from 'react';
import { Marker } from 'react-map-gl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { faClock } from '@fortawesome/pro-solid-svg-icons';
import { Port } from '@api/utils/ports';
import styles from './TentativeBookingsMarker.module.css';

type TentativeBookingsMarkerProps = {
	loadingPort: Port;
	isSelected: boolean;
	onLoadingPortClick: (p: Port) => void;
};

const TentativeBookingsMarker = ({
	loadingPort,
	isSelected,
	onLoadingPortClick,
}: TentativeBookingsMarkerProps) => {
	return (
		<Marker
			key={`marker-${loadingPort.name}`}
			longitude={loadingPort.longitude}
			latitude={loadingPort.latitude}
			className={styles.tentativeBooking}
			offsetTop={-14}
			offsetLeft={-14}
		>
			<span className="fa-stack">
				<FontAwesomeIcon
					className={classNames(
						styles.markerIcon,
						{ [styles.selectedMarker]: isSelected }
					)}
					size="lg"
					icon={faClock}
					onClick={() => onLoadingPortClick(loadingPort)}
				/>
			</span>
		</Marker>
	);
};

export default TentativeBookingsMarker;
